import { z } from 'zod';
import { createModel } from '../../common';
import { nameSchema } from '../../validation';
/**
 * UTag is a universal tagging system across all collections.
 */
export const UTagSchema = createModel({
  /** Tag Display Name */
  name: nameSchema,
  /** code is like this_is_advance_payment tag */
  code: nameSchema,
  /** description of the tag and use case.*/
  description: nameSchema,
});

export type UTag = z.infer<typeof UTagSchema.model>;

export const UTagSharedSchema = UTagSchema.model.pick({
  _id: true,
  name: true,
  code: true,
});
